import { useKeyboard } from "@/utils/hooks/useKeyboard";
import { defineComponent } from "vue";
import type { UseForm } from "./useForm";
import CodeBlock from "components/code-block";
import { useWindows } from "components/window-manager/hooks/useWindows";


const FormDebugger = defineComponent<{
  form: UseForm<any, any, any>
}>((props) => {
  return () => {
    return <CodeBlock value={JSON.stringify({
      state: props.form.state.value,
      //fields: props.form.fieldList.value,
  //    schema: props.form.schema.value,
    //  errors: props.form.errors.value,
      //layout: props.form.layout.value
    }, undefined, 2)} />
  }
}, { props: ['form'] })


export const useFormDebuggerUI = (form: UseForm<any, any, any>) => {
  const keyboard = useKeyboard()
  const windows = useWindows();



  keyboard.addEventListener('keydown', () => {
    if (keyboard.down('Control') && keyboard.down('Alt') && keyboard.down('f')) {
      windows.push({
        title: 'Form Debugger',
        body: () => <FormDebugger form={form}/>,
        onClose: () => {
        },
        resizable: true
      })
    }
  });
}
